import { WixIcons } from '../../../components/common';
import { Sort } from '../../../constants/Sort';

export const SortSwitcherIcons = {
  [Sort.LastModified]: WixIcons.SortDescending,
  [Sort.OldestFirst]: WixIcons.SortAscending,
  [Sort.AZ]: WixIcons.SortAZ,
  [Sort.ZA]: WixIcons.SortZA,
};
